<template>
  <div id="HomePage">
    <Navigation hideLogo="true" v-if="!isUserLoggedIn" page="mainPage" backgroundColor="rgba(0,0,0, 0.4)" :showUserNav="true"></Navigation>
    <Navigation hideLogo="true" v-if="isUserLoggedIn" page="mainPage" :showUserNav="true"></Navigation>
    <div class="view hm-blue-slight" v-bind:class="{userLoggedIn: isUserLoggedIn}">
      <div class="full-bg-img p-t-6">
      <Carousel class="carousel" :images="images" :interval="5000"/>
        <div class="container-fluid mainContent">
          <img class="logo m-t-3 m-b-3" src="/static/img/logo-booknatura-green.svg" width="200px">
          <div class="white-text text-xs-center wow fadeInUp">
            <h2>{{t('Discover the natural wonders of Portugal')}}</h2>
            <h5 class="tagline">{{t('Book your tours, adventure activities or nature watching')}}</h5>
            <search class="m-t-4 m-b-4 z-depth-4"></search>
          </div>
        </div>
      </div>
    </div>
    <Newsletter/>
    <Recomendations></Recomendations>
    <HowDoesItWork></HowDoesItWork>
    <SearchLinks class="m-b-3"></SearchLinks>
    <Testimonials></Testimonials>
    <Mission></Mission>
  </div>
  </div>
  </div>
</template>


<script>
import Navigation from '../Navigation/Navigation';
import Recomendations from './Recomendations';
import Mission from './Mission';
import Testimonials from './Testimonials';
import Carousel from '../Carousel';
import HowDoesItWork from './HowDoesItWork';
import Search from './Search';
import TextInput from '../Form/V1/TextInput';
import SearchLinks from '../Search/SearchLinks';
import Newsletter from './Newsletter';

export default {
  name: 'HomePage',
  components: {
    'Text-Input': TextInput,
    Navigation,
    Search,
    Testimonials,
    Carousel,
    Recomendations,
    HowDoesItWork,
    SearchLinks,
    Mission,
    Newsletter,
  },
  data() {
    return {
      images: [
        {
          large_path: '/static/img/slideshow/1.jpg',
        }, {
          large_path: '/static/img/slideshow/2.jpg',
        }, {
          large_path: '/static/img/slideshow/3.jpg',
        },
      ],
    };
  },
  computed: {
    isUserLoggedIn() {
      if (typeof this.$store.state.userDeprecated.data.username !== 'undefined') {
        if (this.$store.state.userDeprecated.data.username !== '') {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";

#HomePage {
  background-color: #FAF3EB;
}

html,
body,
header {
  height: 100vh;
}
.view {
  min-height: 85vh;
  max-height: 1000px;
  .logo {
    margin: auto;
  }
}

@media (min-width: 768px) {
  .view {
    /*overflow: visible; TODO: hides newsletter signup or hides part of the carousel interface. Fix */
  }
  .view.isUserLoggedIn {
    margin-top: 0;
  }
}
.full-bg-img {
  position: relative;
  min-height: 85vh;
  // max-height: 1000px;
  overflow: visible;
  z-index: 1000;
}
.view {
  /*background-color: #333 !important;
  /*background: url("/static/img/canoing3.jpg") no-repeat center center fixed;
  background-size: cover;*/
}
.carousel {
  top: 0;
  position:absolute !important;
  overflow: visible;
  width: 100vw;
}
.mainContent {
  position: relative;
  z-index: 1000;
}

h2, h5 {
  text-shadow: 0px 0px 10px rgba(150, 150, 150, 1);
}

.tagline {
  letter-spacing: 0.05em;
  opacity: 0.9;
  font-size: 1.3rem;
  margin-top: 30px;
  margin-bottom: 70px;
}


@media #{$small-and-down} {
  h2 { font-size: 24px; }
}

@media #{$small-and-down} {
  .full-bg-img {
    padding-top: 0 !important;

  }

}
</style>



// WEBPACK FOOTER //
// Home.vue?940724b2